import {
  Component,
  ElementRef,
  Input,
  OnInit,
  signal,
  ViewChild,
  ViewEncapsulation,
  WritableSignal,
} from '@angular/core';
import { PlIcon } from '@app/icon-library/icons';
import { MatMenuTrigger } from '@angular/material/menu';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { isTouchDevice } from '@app/utils/device';
import { PositionX, PositionY } from '../pl-popover/pl-popover.component';

export interface MenuItemTooltip {
  label: string;
  value: string | null;
  displayByDefault?: boolean;
  click: () => void | Promise<void>;
}

@Component({
  selector: 'pl-menu-tooltip',
  templateUrl: './menuTooltip.component.html',
  styleUrls: ['./menuTooltip.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MenuTooltipComponent implements OnInit {
  @Input() public menuIcon: PlIcon | null = null;
  @Input() public menuItems: MenuItemTooltip[] = [];

  @Input() public hideToolTipAndAlternateValueOnButton: boolean = false;

  @ViewChild(MatMenuTrigger) public trigger!: MatMenuTrigger;

  public menuItemSelected: MenuItemTooltip | undefined;

  public readonly PlIcon: typeof PlIcon = PlIcon;
  public readonly PositionX: typeof PositionX = PositionX;
  public readonly PositionY: typeof PositionY = PositionY;

  private mouseEventMenuSubject: Subject<boolean> = new Subject<boolean>();

  private isTouchDevice: boolean = isTouchDevice();

  @ViewChild('buttonToLinkPopover') public buttonToLinkPopover!: ElementRef;

  public showMenu: WritableSignal<boolean> = signal(false);

  public ngOnInit(): void {
    this.menuItemSelected = this.menuItems.find((menuItem: MenuItemTooltip) => menuItem.displayByDefault);
    this.watchMouseEvent();
  }

  private watchMouseEvent(): void {
    this.mouseEventMenuSubject.pipe(debounceTime(300)).subscribe((open: boolean) => {
      console.log('TONIO MenuTooltipComponent watchMouseEvent open=', open);
      if (open) {
        this.openMenu();
      } else {
        this.closeMenu();
      }
    });
  }

  public onMainMenuButtonClicked(): void {
    console.log('TONIO MenuTooltipComponent onMainMenuButtonClicked =');
    this.openMenu();
  }

  public onPopoverDismissed(): void {
    console.log('TONIO MenuTooltipComponent onPopoverDismissed =');
    this.closeMenu();
  }

  public onMenuItemClicked(menuItem: MenuItemTooltip): void {
    console.log('TONIO MenuTooltipComponent onMenuItemClicked =');
    this.closeMenu();
    menuItem.click();
    this.menuItemSelected = menuItem;
  }

  public mouseEnterMenu(): void {
    console.log('TONIO MenuTooltipComponent mouseEnterMenu this.isTouchDevice=', this.isTouchDevice);
    if (!this.isTouchDevice) {
      this.mouseEventMenuSubject.next(true);
      this.openMenu();
    }
  }

  public mouseLeaveMenu(): void {
    console.log('TONIO MenuTooltipComponent mouseLeaveMenu =');
    this.mouseEventMenuSubject.next(false);
  }

  private openMenu(): void {
    console.log('TONIO MenuTooltipComponent openMenu =');
    this.showMenu.set(true);
  }

  private closeMenu(): void {
    console.log('TONIO MenuTooltipComponent closeMenu =');
    this.showMenu.set(false);
  }
}
